/*
 * Wishlist: the shopper's saved designs, kept in this browser (localStorage key `dw_wishlist`,
 * a list of product handles, newest first). Every heart button on the page
 * (`[data-dw-wish="<handle>"]`) reflects the list, the header count follows it, and the
 * <dw-wishlist> element on the Wishlist page draws the saved products from the store's
 * product JSON. Nothing here needs an account.
 */
(function () {
  var KEY = 'dw_wishlist';
  var LIMIT = 100;
  var list = read();

  function read() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(saved) ? saved.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write() {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function has(handle) {
    return list.indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var index = list.indexOf(handle);
    if (index === -1) {
      list.unshift(handle);
      if (list.length > LIMIT) list.length = LIMIT;
    } else {
      list.splice(index, 1);
    }
    write();
    sync();
    document.dispatchEvent(new CustomEvent('dw:wishlist', { detail: { handle: handle, saved: index === -1, count: list.length } }));
  }

  /* Puts every heart and the header count in step with the list. */
  function sync() {
    document.querySelectorAll('[data-dw-wish]').forEach(function (button) {
      var saved = has(button.dataset.dwWish);
      var pressed = String(saved);
      if (button.getAttribute('aria-pressed') !== pressed) {
        button.setAttribute('aria-pressed', pressed);
        button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
      }
    });
    document.querySelectorAll('[data-dw-wish-count]').forEach(function (badge) {
      var text = list.length > 99 ? '99+' : String(list.length);
      /* Written only on change: the badge is inside the subtree the observer below watches. */
      if (badge.textContent !== text) badge.textContent = text;
      if (badge.hidden !== (list.length === 0)) badge.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-dw-wish]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(button.dataset.dwWish);
  }, true);

  /* Hearts inside re-rendered markup (cart drawer, filtered grids) pick up their state as they appear. */
  /* Only added markup that holds a heart or the count matters; every other change on the page is ignored. */
  var WATCHED = '[data-dw-wish], [data-dw-wish-count]';
  var pending = false;
  function holdsHeart(records) {
    for (var i = 0; i < records.length; i++) {
      var nodes = records[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType === 1 && (node.matches(WATCHED) || node.querySelector(WATCHED))) return true;
      }
    }
    return false;
  }
  new MutationObserver(function (records) {
    if (pending || !holdsHeart(records)) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) { list = read(); sync(); }
  });
  sync();

  window.DawoofieWishlist = { has: has, toggle: toggle, handles: function () { return list.slice(); } };

  /*
    <dw-wishlist>: the Wishlist page. Loads each saved product's JSON and shows it as a card
    with a heart to remove it. The empty message is the element's own markup.
  */
  function Wishlist() {
    return Reflect.construct(HTMLElement, [], Wishlist);
  }
  Wishlist.prototype = Object.create(HTMLElement.prototype);
  Wishlist.prototype.constructor = Wishlist;

  Wishlist.prototype.connectedCallback = function () {
    var self = this;
    this.grid = this.querySelector('[data-dw-wishlist-grid]');
    this.empty = this.querySelector('[data-dw-wishlist-empty]');
    this.cards = {};
    this.render();
    document.addEventListener('dw:wishlist', function () { self.render(); });
  };

  Wishlist.prototype.render = function () {
    var self = this;
    var handles = list.slice();
    this.empty.hidden = handles.length > 0;
    this.grid.hidden = handles.length === 0;
    /* Cards of removed products go; new ones are fetched once and kept. */
    Object.keys(this.cards).forEach(function (handle) {
      if (handles.indexOf(handle) === -1) {
        self.cards[handle].remove();
        delete self.cards[handle];
      }
    });
    handles.forEach(function (handle, position) {
      if (self.cards[handle]) {
        self.grid.appendChild(self.cards[handle]);
        return;
      }
      var card = document.createElement('article');
      card.className = 'dw-card dw-wishlist__card';
      card.style.order = String(position);
      self.cards[handle] = card;
      self.grid.appendChild(card);
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.ok ? response.json() : Promise.reject(response.status); })
        .then(function (product) { self.fill(card, product); })
        .catch(function () {
          /* A product that is gone from the store leaves the list quietly. */
          if (has(handle)) toggle(handle);
        });
    });
  };

  Wishlist.prototype.fill = function (card, product) {
    var template = this.querySelector('template');
    card.appendChild(template.content.cloneNode(true));
    var url = '/products/' + product.handle;
    var line = /washed-tee$/.test(product.handle) ? 'Washed Tee' : 'Soft Tee';
    var name = product.title.replace(/\s+(Washed Tee|T-Shirt|Soft Tee)$/i, '');
    var image = product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=900' : '';
    card.querySelectorAll('a').forEach(function (link) { link.href = url; });
    var img = card.querySelector('img');
    if (image) { img.src = image; img.alt = ''; } else { img.remove(); }
    card.querySelector('[data-dw-wishlist-name]').textContent = name;
    card.querySelector('[data-dw-wishlist-line]').textContent = line;
    card.querySelector('[data-dw-wishlist-price]').textContent = this.money(product.price);
    var heart = card.querySelector('[data-dw-wish]');
    heart.dataset.dwWish = product.handle;
    sync();
  };

  Wishlist.prototype.money = function (cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100);
    }
  };

  if (!customElements.get('dw-wishlist')) customElements.define('dw-wishlist', Wishlist);
})();
